<template>
  <div class="template">
    <div class="container">
      <div v-for="item in SCREEN_TEMPLATE_LIST" :key="item.templateId" class="item">
        <div class="screen-img-wrap">
          <div class="item-img-box">
            <img :src="item.panelThumbnail" alt="" />
            <div class="review" @click="handleShowReviewDialog(item)">
              预览
            </div>
          </div>
        </div>
        <div class="item-title">{{ item.panelName }}</div>
      </div>
    </div>
    <ReviewDialog v-if="reviewDialogShow" :review-obj="reviewObj" @close="handleCloseReviewDialog"></ReviewDialog>
  </div>
</template>

<script>
import ReviewDialog from './reviewDialog.vue'
import { SCREEN_TEMPLATE_LIST } from '@/utils/defaultTemplateData.js'
export default {
  name: 'ScreenTemplates',
  components: {
    ReviewDialog,
  },
  data () {
    return {
      SCREEN_TEMPLATE_LIST,
      reviewDialogShow: false,
      reviewObj: {},
    }
  },
  methods: {
    handleShowReviewDialog (val) {
      this.reviewObj = val
      this.reviewDialogShow = true
    },
    handleCloseReviewDialog () {
      this.reviewObj = {}
      this.reviewDialogShow = false
    },

  },
}
</script>

<style lang="scss" scoped>
  .template{
    display: flex;
    justify-content: center;
    .container{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 1110px;
      .item{
        width: 350px;
        // height: 200px;
        margin: 0 30px 20px 0;
        transition: all 500ms ease 0s;
        &:hover{
          transform: translateY(-10px);
          transition: all 500ms ease 0s;
          .item-title{
            color: #3269FF;
          }
          .item-img-box>.review{
            display: flex;
          }
        }
        .screen-img-wrap{
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .item-img-box{
          display: inline-block;
          font-size: 0;
          box-shadow: 3px 3px 12px rgba(0,0,0,0.2);
          opacity: 1;
          border-radius: 8px;
          position: relative;
          img{
            max-width: 350px;
            max-height: 180px;
            border-radius: 8px;
          }

          .review{
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            border-radius: 8px;
            display: none;
            align-items: center;
            justify-content: center;
            background-color: rgba(0,0,0,0.5);
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer
          }
        }
        .item-title{
          margin-top: 10px;
          text-align: center;
          color: #4E4E4E;
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

</style>
